import { Delete, Get, Post, Put } from './http.svc'

export const getSwmsStore = (status = null) =>
    Get(`swms/store${status ? `?status=${status}` : ''}`)

export const getSwmsStoreItem = (id) => Get(`swms/store/${id}`)

export const createSwmsDraft = (data) => Post('swms/store', data)

export const updateSwmsDraft = (id, data) => Put(`swms/store/${id}`, data)

export const deleteSwmsDraft = (id) => Delete(`swms/store/${id}`)

export const copySwms = (id) => Post(`swms/store/${id}/copy`)

export const downloadSwmsStorePdf = (id) =>
    Get(`swms/store/${id}/pdf`, { rawResponse: true })

export const publishSwms = (id) => Post(`swms/store/${id}/publish`)

export const retireSwms = (id) => Post(`swms/store/${id}/retire`)
